/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class BranchOfficeModalityRequest extends MainRequest{

  
     static listAllByBranchOffice(data) {
         return this.postSEC(ServicePath.BRANCH_OFFICE_MODALITY_LIST_ALL_BY_BRANCH_OFFICE, data);
     }
     static listAllByBranchOfficeActive(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_MODALITY_LIST_ALL_BY_BRANCH_OFFICE_ACTIVE, data);
    }

     static add(object) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_MODALITY_ADD, object);
     }

     static update(object) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_MODALITY_UPDATE, object);
     }

     static get(object) {
         return object;
     }

     static delete(object) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_MODALITY_DELETE, object);
     }

 }